import { Component, Input } from '@angular/core';
import { MessageItem } from '@interfaces';
import { formatTextStyle } from '@utils';

@Component({
  selector: 'unicon-message-item',
  templateUrl: './message-item.component.html',
  styleUrl: './message-item.component.scss',
})
export class MessageItemComponent {
  @Input() fromName!: string;
  @Input() hasFromName: boolean = false;
  @Input() item!: MessageItem;
  @Input() buttonLinkResponse: boolean = false;

  protected formatText(text: string): string {
    text = formatTextStyle(text);

    return text;
  }
}
